import { Button, Card } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useMutation } from '@apollo/client'

import { RootState } from 'app/rootReducer'
import GoBackHeader from 'components/organisms/GoBackHeader'
import {
  ResetCredentialsResponse,
  ResetCredentialsVariables,
  RESET_CREDENTIALS
} from 'share/mutations/account'

import './styles.scss'

interface ForgotDataProps {
  forgotPassword: boolean
  forgotUser: boolean
  lastName: string
  mobilePhone: string
}

function LoginForgotValidate(): JSX.Element {
  const history = useHistory()
  const ForgotData: ForgotDataProps = history.location.state as ForgotDataProps
  const forgotPasswordData = useSelector(
    (state: RootState) => state.forgotPasswordData
  )
  const [doForgot, { loading }] =
    useMutation<ResetCredentialsResponse, ResetCredentialsVariables>(
      RESET_CREDENTIALS
    )

  return (
    <>
      <GoBackHeader text='Forgot Login Credentials' />
      <div className='ui-forgot-validate-page px-4 mt-4 mt-lg-5'>
        <h3 data-testid='login-forgot-email-cred-title'>
          Your login credentials have been sent to
        </h3>
        <Card>
          <Card.Body>
            <span className='mdi mdi-email-outline' />
            <div className='ui-forgot-validate-page-detail'>
              <p>Email</p>
              <span>Sent to {forgotPasswordData.maskedEmail}</span>
            </div>
          </Card.Body>
        </Card>
        Check your inbox and follow the instructions in order to access your
        account.
        <span className='ui-forgot-validate-notes'>
          Didn't recieve your credentials?{' '}
          <Button
            variant='link'
            data-testid='login-forgot-email-cred-sendagain-link'
            onClick={() => {
              doForgot({
                variables: ForgotData
              })
            }}
          >
            Send it again
            {loading && <span className='mdi mdi-update mdi-spin' />}
          </Button>
        </span>
        <Button
          className='ui-button-with-spinner'
          data-testid='login-forgot-email-cred-continue-button'
          onClick={() => {
            if (forgotPasswordData.forgotPasswordChecked) {
              history.push('/login/reset')
            } else {
              history.push('/login')
            }
          }}
        >
          Continue
        </Button>
      </div>
    </>
  )
}

export default LoginForgotValidate
